import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { RxMark } from './PrescriptionBadge';
import { money } from './QuantityStepper';
import { builderPrices } from '../data/builder';
import { rxInsertConnected } from '../utils/cartAddons';
interface RxQuantityControlProps {
  value: number;
  max: number;
  onChange: (next: number) => void;
  className?: string;
}

/**
 * RX Capability Inserts, chosen by quantity on Complete Systems and multipacks.
 * Starts at 0 and never follows the pack size. Hidden until the RX product is connected in Shopify.
 */
export function RxQuantityControl({
  value,
  max,
  onChange,
  className = ''
}: RxQuantityControlProps) {
  if (!rxInsertConnected()) return null;
  const clamped = Math.min(value, max);
  return <div className={`border border-[#7fe3ec]/30 bg-[#07242a]/60 p-3.5 ${className}`} data-id="element-1211" data-mp="3si8wbcxa52qg">
      <div className="flex items-center justify-between gap-3" data-id="element-1212" data-mp="1vndxbr2doz8b">
        <p className="flex items-center gap-2.5" data-id="element-1213" data-mp="1qojfarc8jep9">
          <RxMark className="h-7 w-7 shrink-0" data-id="element-1214" data-mp="1qmq2svexy09c" />
          <span data-id="element-1215" data-mp="bwx550fawnrf">
            <span className="block text-[13px] font-bold uppercase leading-tight tracking-wide text-offwhite" data-id="element-1216" data-mp="bwf3fo9vdhc4">
              {max > 1 ? 'How many need RX capability?' : 'Add RX capability?'}
            </span>
            <span className="block text-[12px] text-steel-400" data-id="element-1217" data-mp="2y33gvn45770">
              +{money(builderPrices.rxInsert)} each · insert only, lenses not included
            </span>
          </span>
        </p>
        <div className="flex shrink-0 items-center border border-white/15" data-id="element-1218" data-mp="vlpg0tebjm60">
          <button type="button" aria-label="Remove one RX insert" disabled={clamped <= 0} onClick={() => onChange(clamped - 1)} className="flex h-9 w-9 items-center justify-center text-offwhite transition-colors duration-150 ease-grit hover:bg-white/10 disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-grit-500" data-id="element-1219" data-mp="zlpu2cxi9vcj">
            <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-1220" data-mp="1jcuvh7gckcfs" />
          </button>
          <span aria-live="polite" className="w-8 text-center font-display text-lg font-extrabold tabular-nums text-offwhite" data-id="element-1221" data-mp="1t68ml3q520s5">
            {clamped}
          </span>
          <button type="button" aria-label="Add one RX insert" disabled={clamped >= max} onClick={() => onChange(clamped + 1)} className="flex h-9 w-9 items-center justify-center text-offwhite transition-colors duration-150 ease-grit hover:bg-white/10 disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-grit-500" data-id="element-1222" data-mp="1j7rrpvo2x20t">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-1223" data-mp="10icrg3g7wgxh" />
          </button>
        </div>
      </div>
      {clamped > 0 && <p className="mt-2 text-right text-[12px] font-semibold text-[#7fe3ec]" data-id="element-1224" data-mp="qjvumpull83i">
          + {money(clamped * builderPrices.rxInsert)} at checkout
        </p>}
    </div>;
}